var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.groups),function(group,gindex){return _c('v-col',{key:gindex,attrs:{"cols":"12","md":"6"}},[_c('Block',{attrs:{"items":group.items,"currency":group.currency,"loading":_vm.loading},on:{"refresh":_vm.load}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }